import React from "react";
//#region types
import { FormEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { UtilFormTypes } from "models/formTypes";
import { ExpandableSectionProps, FormFieldDefinitionType, GenericFormSection } from "models/propTypes/genericFormProps";
import { getCostForwardingSectionSubText } from "./costForwardingMarkingModel";
//#endregion
//#region components
import { useFormikContext } from "formik";
import connectToForm from "components/common/wintForms/connectToForm";
import CostForwardingFields from "./costForwardingFields";
import { useCostForwardingMarkingContext } from "./costForwardingMarkingContext";
import { getCostForwardingSectionSubTextText } from "./costForwardingStatusText";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const CostForwardingFormikFields: React.FC = () => {
  const formik = useFormikContext<UtilFormTypes.CostForwardingMarking>();
  const { marking } = useCostForwardingMarkingContext();

  return (
    <CostForwardingFields connect={(name) => connectToForm(formik, name)} values={formik.values} marking={marking} />
  );
};

/**
 * The "Vidarefakturering" step for a to-do form still on GenericForm.
 * Shown once the form's values say the marking is available, so pair it with CostForwardingFormHandleSync.
 */
function useCostForwardingGenericFormSection<T extends UtilFormTypes.CostForwardingMarking>(): GenericFormSection<T> {
  const { marking } = useCostForwardingMarkingContext();
  const statusText = getCostForwardingSectionSubTextText(getCostForwardingSectionSubText(marking));

  return {
    label: TranslationKeys.CostForwarding.Title,
    type: FormEnums.FormSectionType.EXPANDABLESECTION,
    hidden: (values: T) => !values.costForwardingAvailable,
    extraProps: {
      initiallyOpen: marking !== undefined,
      summaryFormatter: () => statusText,
    } as ExpandableSectionProps,
    innerFields: [
      {
        type: FormEnums.FormSectionType.FIELDGROUPSECTION,
        label: "",
        className: cssExports.noBorder,
        innerFields: {
          costForwardingCustomer: {
            label: "",
            type: FormEnums.FormFieldType.CUSTOM,
            customField: <CostForwardingFormikFields />,
            classes: { formControl: cssExports.wintFormFieldsInGenericForm },
          },
        } as FormFieldDefinitionType<T>,
      },
    ],
  };
}

export default useCostForwardingGenericFormSection;
